import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class IosIntentService {
  constructor(private platform: Platform) {}

  async checkForSharedContent(): Promise<any> {
    if (this.platform.is('ios') && this.platform.is('capacitor')) {
      try {
        // Check for URL scheme data
        const urlData = await this.checkUrlScheme();
        if (urlData) {
          return urlData;
        }

        // Check for document sharing
        const documentData = await this.checkDocumentSharing();
        if (documentData) {
          return documentData;
        }

        // Check for universal links
        const universalLinkData = await this.checkUniversalLinks();
        if (universalLinkData) {
          return universalLinkData;
        }
      } catch (error) {
        console.error('Error checking iOS shared content:', error);
      }
    }
    return null;
  }

  private async checkUrlScheme(): Promise<any> {
    // Check if the app was opened via URL scheme
    const url = window.location.href;
    if (url.includes('ivydental://')) {
      const urlParams = new URLSearchParams(url.split('?')[1] || '');
      const sharedText = urlParams.get('text');
      const sharedFile = urlParams.get('file');
      
      if (sharedText) {
        return {
          type: 'text',
          content: sharedText
        };
      }
      
      if (sharedFile) {
        return {
          type: 'file',
          content: sharedFile
        };
      }
    }
    return null;
  }

  private async checkDocumentSharing(): Promise<any> {
    // Check for document sharing via iOS document picker
    // This would typically be handled by a native plugin
    // For now, we'll check for any document-related URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const documentUrl = urlParams.get('document') || urlParams.get('shared_document');
    
    if (documentUrl) {
      return {
        type: 'document',
        content: documentUrl
      };
    }
    return null;
  }

  private async checkUniversalLinks(): Promise<any> {
    // Check for universal links
    const url = window.location.href;
    if (url.includes('ivydental.com.tw') || url.includes('app.ivydental.com.tw')) {
      const urlParams = new URLSearchParams(url.split('?')[1] || '');
      const sharedText = urlParams.get('text');
      const sharedFile = urlParams.get('file');
      
      if (sharedText) {
        return {
          type: 'text',
          content: sharedText
        };
      }
      
      if (sharedFile) {
        return {
          type: 'file',
          content: sharedFile
        };
      }
    }
    return null;
  }

  // Method to handle iOS app delegate calls
  public handleAppDelegateData(data: any) {
    console.log('iOS app delegate data:', data);
    
    if (data && data.url) {
      const url = new URL(data.url);
      const sharedText = url.searchParams.get('text');
      const sharedFile = url.searchParams.get('file');
      
      if (sharedText) {
        return {
          type: 'text',
          content: sharedText
        };
      }
      
      if (sharedFile) {
        return {
          type: 'file',
          content: sharedFile
        };
      }
    }
    
    return null;
  }
}







